import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=4f8013cf"
import script from "./Group.vue?vue&type=script&lang=ts"
export * from "./Group.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f8013cf')) {
      api.createRecord('4f8013cf', component.options)
    } else {
      api.reload('4f8013cf', component.options)
    }
    module.hot.accept("./Group.vue?vue&type=template&id=4f8013cf", function () {
      api.rerender('4f8013cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/Group.vue"
export default component.exports